import { useState } from 'react'

import type { MembershipsCreatorV2ApiClient } from '@fourthwall/services/dist/MembershipsCreatorV2ApiClient'
import { useCreateImageResources } from '@modules/Dashboard/Memberships/hooks/useCreateImageResources'

import { useCreateLiveStreamPostMutation } from './useCreateLiveStreamPostMutation'

export const useCreateLiveStreamPost = () => {
  const [isLoading, setLoading] = useState(false)

  const { createLiveStreamPostMutation } = useCreateLiveStreamPostMutation()
  const { createImageResources } = useCreateImageResources()

  const createLiveStreamPost = async (
    thumbnail: File,
    payload: Parameters<typeof MembershipsCreatorV2ApiClient.createLiveStreamPost>[0],
    handleSuccess: () => void,
  ) => {
    setLoading(true)

    if (thumbnail) {
      await createImageResources({
        files: [thumbnail],
        onSuccess: (images) => {
          payload.imageResourceId = images[0].id
        },
      })
    }

    await createLiveStreamPostMutation.mutateAsync([payload], {
      onSuccess: handleSuccess,
      onError: () => setLoading(false),
    })
  }

  return {
    createLiveStreamPost,
    isLoading,
  }
}
